import React from "react";
import styles from "./SmartSend.module.css";

export default function DeliveryDateSelection({
  Address,
  time,
  date,
  toggleModal,
  errorNotify,
  parent,
  config,
  type,
}) {
  return (
    <>
      {!!config?.defaultText && (
        <p className="my-3 text-black-50">{config?.defaultText}</p>
      )}
      <div className={styles.schedule_wrap}>
        <div className={styles.schedule_text}>
          {type === "goody" ? "Scheduled to send on" : "Scheduled Delivery"}
        </div>
        {Address !== "Please select an address" ? (
          <button
            className={styles.schedule_btn}
            onClick={() => toggleModal(parent)}
          >
            Set Date
          </button>
        ) : (
          <button
            className={styles.schedule_btn}
            onClick={() =>
              errorNotify("Please select an address before setting a date.")
            }
          >
            Set Date
          </button>
        )}
      </div>
      <div className={styles.schedule_wrap}>
        <div className={styles.info_title_text}>Date</div>
        {Address !== "Please select an address" ? (
          <span
            className={styles.info_text}
            onClick={() => toggleModal(parent)}
          >
            {date}
          </span>
        ) : (
          <span
            className={styles.info_text}
            onClick={() =>
              errorNotify("Please select an address before setting a date.")
            }
          >
            {date}
          </span>
        )}
      </div>
      {config?.displayDeliveryTime && (
        <div className={styles.schedule_wrap}>
          <div className={styles.info_title_text}>Time</div>
          {Address !== "Please select an address" ? (
            <span
              className={styles.info_text}
              onClick={() => toggleModal(parent)}
            >
              {time}
            </span>
          ) : (
            <span
              className={styles.info_text}
              onClick={() =>
                errorNotify("Please select an address before setting a date.")
              }
            >
              {time}
            </span>
          )}
        </div>
      )}
    </>
  );
}
